let endpoint = process.env.REACT_APP_BAKEND

export default {
    // login: (username, password) => {
    //     const URL = `${endpoint}/api/users/authenticate`
    //     return fetch(URL, { method: 'GET', crossDomain: true, port: 5000 })
    //         .then(response => { return Promise.all([response, response.json()]) })
    // },
    login: (username, password) => {
        const URL = `${endpoint}/api/users/authenticate`
        return fetch(URL, {
            method: 'POST',
            body: JSON.stringify({ UserName: username, Password: password }),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    register: (payload) => {
        const URL = `${endpoint}/api/users/register`
        return fetch(URL, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    getCourses: () => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/courses`
        return fetch(URL, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    getAllCourses: () => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/courses/all`
        return fetch(URL, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    getCourse: (id) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/courses/${id}`
        return fetch(URL, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    createCourse: (payload) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/courses`
        return fetch(URL, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    updateCourse: (id, payload) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/courses/${id}`
        return fetch(URL, {
            method: 'PUT',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    deleteCourse: (id) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/courses/${id}`
        return fetch(URL, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    uploadCover: (courseId, file) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/courses/uploadCover`
        let data = new FormData()
        data.append('file', file)
        data.append('id', courseId)

        return fetch(URL, {
            method: 'POST',
            body: data,
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    getVideos: (courseId, u) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/courses/${courseId}/videos?u=${u ? u : ''}`
        return fetch(URL, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    getS3: () => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/videos/s3/list`
        return fetch(URL, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    createVideo: (payload, courseId) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/videos?courseId=${courseId}`
        return fetch(URL, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    updateVideo: (id, payload) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/videos/${id}`
        return fetch(URL, {
            method: 'PUT',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    uploadVideo: (courseId, file, title, description, duration) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/videos/uploadVideoToS3`
        let data = new FormData()
        data.append('file', file)
        data.append('title', title)
        data.append('description', description)
        data.append('courseId', courseId)
        data.append('duration', duration)

        return fetch(URL, {
            method: 'POST',
            body: data,
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    uploadOverrideVideo: (videoId, file, title, description, duration) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/videos/uploadVideoToS3`
        let data = new FormData()
        data.append('file', file)
        data.append('title', title)
        data.append('description', description)
        data.append('videoId', videoId)
        data.append('duration', duration)

        return fetch(URL, {
            method: 'POST',
            body: data,
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    deleteVideo: (id) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/videos/${id}`
        return fetch(URL, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    getUsers: (all) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/users?all=${all ? all : false}`
        return fetch(URL, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    getUsersPaged: (page, pageSize, term, all) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const params = new URLSearchParams({
            page: page || 1,
            pageSize: pageSize || 20,
            all: all ? true : false,
        })
        if (term) params.append('term', term)
        const URL = `${endpoint}/api/users/page?${params.toString()}`
        return fetch(URL, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    getInstructor: () => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/users/instructor`
        return fetch(URL, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    getUser: (userName) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/users/${userName}`
        return fetch(URL, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    createUser: (payload) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/users`
        return fetch(URL, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    updateUser: (id, payload) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/users/${id}`
        return fetch(URL, {
            method: 'PUT',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    toggleUser: (id) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/users/toggle?id=${id}`
        return fetch(URL, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    deleteUser: (id) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/users/${id}`
        return fetch(URL, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    createMyCourse: (courseId, payload) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/mycourse?courseId=${courseId}`
        return fetch(URL, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    updateMyCourse: (id, payload) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/mycourse/${id}`
        return fetch(URL, {
            method: 'PUT',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    getMyCourse: (userName) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/mycourse/list?user=${userName ? userName : user.userName}`
        return fetch(URL, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    getAllRegisterCourse: () => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/mycourse?all=true`
        return fetch(URL, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    getAllRegisterCoursePaged: (page, pageSize, term, level, course, all) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const params = new URLSearchParams({
            page: page || 1,
            pageSize: pageSize || 20,
            all: all === false ? false : true,
        })
        if (term) params.append('term', term)
        if (level) params.append('level', level)
        if (course) params.append('course', course)
        const URL = `${endpoint}/api/mycourse/page?${params.toString()}`
        return fetch(URL, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    deleteMyCourse: (id) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/mycourse/${id}`
        return fetch(URL, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    toggleMyCourse: (id) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/mycourse/toggle?id=${id}`
        return fetch(URL, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    getDepartments: (all, includeCourse) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/departments?all=${all ? all : false}&includeCourse=${includeCourse ? includeCourse : false}`
        return fetch(URL, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    getDepartment: (id) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/departments/${id}`
        return fetch(URL, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    createDepartment: (payload) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/departments`
        return fetch(URL, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    updateDepartment: (id, payload) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/departments/${id}`
        return fetch(URL, {
            method: 'PUT',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    deleteDepartment: (id) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/departments/${id}`
        return fetch(URL, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    toggleDepartment: (id) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/departments/toggle?id=${id}`
        return fetch(URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    getSubjects: (all) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/subjects?all=${all ? all : false}`
        return fetch(URL, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    getSubject: (id) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/subjects/${id}`
        return fetch(URL, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    createSubject: (payload) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/subjects`
        return fetch(URL, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    updateSubject: (id, payload) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/subjects/${id}`
        return fetch(URL, {
            method: 'PUT',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    deleteSubject: (id) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/subjects/${id}`
        return fetch(URL, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    toggleSubject: (id) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/subjects/toggle?id=${id}`
        return fetch(URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    searchCourse: (term) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/courses/search?term=${term}`
        return fetch(URL, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    searchAllCourse: (term) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/courses/all/search?term=${term}`
        return fetch(URL, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    searchMyCourse: (userName, term) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/mycourse/search?user=${userName ? userName : user.userName}&term=${term}`
        return fetch(URL, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    addHistory: (payload) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/history`
        return fetch(URL, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    getHistoryByUser: (u) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/history/${u}`
        return fetch(URL, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    toggleHistory: (id) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/history/toggle?id=${id}`
        return fetch(URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    logPlaybackEvent: (payload) => {
        // ใช้ keepalive=true ให้ request ยิงออกได้แม้หน้าจะถูกปิดทันทีหลัง error
        const user = JSON.parse(sessionStorage.getItem('user'))
        if (!user || !user.token) return Promise.resolve()
        const URL = `${endpoint}/api/playbackevents`
        return fetch(URL, {
            method: 'POST',
            body: JSON.stringify(payload),
            keepalive: true,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + user.token
            }
        }).catch(() => { /* log-only endpoint, อย่าทำให้ player ล้ม */ })
    },
    getConfiguration: (u) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/config/news`
        return fetch(URL, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
    updateConfiguration: (news) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const URL = `${endpoint}/api/config/news`
        return fetch(URL, {
            method: 'POST',
            body: JSON.stringify({ news: news }),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
    },
}